import gql from 'graphql-tag';

const handQueries = {
  Hands: gql`
    query {
      hands {
        id
        title
        status
      }
    }
  `,
  HandsByParentId: gql`
    query (
      $parentId: Int!,
      $parentType: String!
    ) {
      handsByParentId (
      parentId: $parentId,
      parentType: $parentType
    ) {
        id
        pbnId
        title
        status
        orderBy
        freeToPlay
      }
    }
  `,
  HandsByProductIdAndUserId: gql`
    query ($productId: Int!) {
      handsByProductIdAndUserId (productId: $productId) {
        id
        title
        freeToPlay
        userHands {
          id
          status
          step
        }
      }
    }
  `, // the userId is taken from the cookie (context)
  HandById: gql`
    query ($id: Int!) {
      handById (id: $id) {
        id
        title
        status
        freeToPlay
        canPlay
        handJSON
        userHands {
          id
          status
          step
        }
        product {
          id
          type
          title
          author {
            id
            fullName
            avatarPath
          }
        }
        article {
          id
          title
          subscription {
            id
            title
            author {
              id
              fullName
              avatarPath
            }
          }
        }
      }
    }
  `
};

export default handQueries;
